import Index from '@tunnel-components/@sharded/pathSVG/container'

/**
 * @export Container
 */

export default Index



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/pathSVG/index.ts